module.exports = __webpack_public_path__ + "static/media/C_S01.6474f41a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_S01.png
// module id = 75
// module chunks = 0